import React from "react";
import "../styles/movieSelectCard.scss";

/**
 * MovieSelectCard — Selectable movie/show card for personalization
 * Figma: MovieSelector component (24654:4778 / 24654:4782)
 *
 * Unselected: white bg, poster image, 267x353px, rounded 8px
 * Selected: dark overlay (rgba(0,0,0,0.6)) with heart icon
 *
 * @param {string} title - Movie/show title
 * @param {string} poster - Poster image URL (placeholder if not provided)
 * @param {boolean} selected - Whether this card is selected
 * @param {function} onClick - Click handler
 */
const MovieSelectCard = ({ title, poster, selected = false, onClick }) => {
  return (
    <div
      className={`mango-movie-select ${
        selected ? "mango-movie-select--selected" : ""
      }`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label={`${selected ? "Deselect" : "Select"} ${title}`}
    >
      {/* Poster placeholder */}
      <div className="mango-movie-select__poster">
        {poster ? (
          <img src={poster} alt={title} className="mango-movie-select__img" />
        ) : (
          <div className="mango-movie-select__placeholder">
            <span>{title}</span>
          </div>
        )}
      </div>

      {/* Selected overlay with heart */}
      {selected && (
        <div className="mango-movie-select__overlay">
          <svg
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mango-movie-select__heart"
          >
            <path
              d="M36 62C35.2 62 34.4 61.7 33.8 61.2C31.2 58.9 28.7 56.7 26.5 54.8L26.4 54.7C19.4 48.6 13.4 43.3 9.2 38.2C4.5 32.4 2.5 27 2.5 21.1C2.5 15.3 4.4 10 8 6.1C11.7 2.1 16.7 0 22.2 0C26.3 0 30 1.3 33.3 3.8C35 5.1 36.6 6.7 38 8.5C39.4 6.7 41 5.1 42.7 3.8C46 1.3 49.7 0 53.8 0C59.3 0 64.3 2.1 68 6.1C71.6 10 73.5 15.3 73.5 21.1C73.5 27 71.5 32.4 66.8 38.2C62.6 43.3 56.6 48.6 49.6 54.7C47.4 56.7 44.9 58.9 42.2 61.2C41.6 61.7 40.8 62 40 62H36Z"
              fill="white"
              transform="translate(0, 5)"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default MovieSelectCard;
